import { render, staticRenderFns } from "./_TaskTitle.vue?vue&type=template&id=7234058d&scoped=true&"
import script from "./_TaskTitle.vue?vue&type=script&lang=js&"
export * from "./_TaskTitle.vue?vue&type=script&lang=js&"
import style0 from "./_TaskTitle.vue?vue&type=style&index=0&id=7234058d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7234058d",
  null
  
)

export default component.exports